// Copyright 2021 Carnegie Mellon University. All Rights Reserved.
// Released under a MIT (SEI)-style license. See LICENSE.md in the project root for license information.
export enum TopbarView {
  STEAMFITTER_ADMIN = 'steamfitter-admin',
  STEAMFITTER_HOME = 'steamfitter-home',
}
